module.exports = __webpack_public_path__ + "static/media/video_banner.a5447ecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_banner.png
// module id = 375
// module chunks = 0